import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
export const AUTH_TITLES = { login: "Sign in", register: "Create account", forgot: "Reset your password" };

export const Field = ({ label, type, ...props }) => {
  const [show, setShow] = useState(false);
  const secret = type === "password";
  return (
    <label className="block">
      <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-widest text-slate-400">{label}</span>
      <span className="relative block">
        <input className={`field ${secret ? "!pr-11" : ""}`} type={secret && show ? "text" : type} {...props} />
        {secret && (
          <button type="button" onClick={() => setShow((v) => !v)} aria-label={show ? "Hide password" : "Show password"} data-testid={`${props["data-testid"] || "password"}-toggle`}
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-1.5 text-slate-500 transition-colors hover:bg-slate-800 hover:text-white">
            {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        )}
      </span>
    </label>
  );
};

export const AuthFields = ({ mode, form, set, onForgot }) => (
  <>
    {mode === "register" && (
      <>
        <Field label="Full name" value={form.name} onChange={set("name")} required data-testid="auth-name-input" />
        <Field label="Company (optional)" value={form.company} onChange={set("company")} data-testid="auth-company-input" />
      </>
    )}
    <Field label="Email" type="email" value={form.email} onChange={set("email")} required data-testid="auth-email-input" />
    {mode !== "forgot" && (
      <Field label="Password" type="password" value={form.password} onChange={set("password")} required minLength={mode === "register" ? 8 : undefined} data-testid="auth-password-input" />
    )}
    {mode === "login" && (
      <button type="button" onClick={onForgot} className="text-xs text-sky-400 hover:underline" data-testid="auth-forgot-link">Forgotten your password?</button>
    )}
  </>
);

export const AuthFeedback = ({ error }) =>
  error ? <p data-testid="auth-error" className="rounded-md border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-sm text-rose-300">{error}</p> : null;

const TOGGLE_LABEL = { login: "New here? Create an account", forgot: "Back to sign in", register: "Already have an account? Sign in" };

export const ModeToggle = ({ mode, onSwitch }) => (
  <button data-testid="auth-toggle-mode" onClick={() => onSwitch(mode === "login" ? "register" : "login")} className="mt-6 w-full text-center text-sm text-slate-400 hover:text-white">
    {TOGGLE_LABEL[mode]}
  </button>
);
